import { render, staticRenderFns } from "./VerifyButton.vue?vue&type=template&id=685f6906&scoped=true"
import script from "./VerifyButton.vue?vue&type=script&lang=js"
export * from "./VerifyButton.vue?vue&type=script&lang=js"
import style0 from "./VerifyButton.vue?vue&type=style&index=0&id=685f6906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685f6906",
  null
  
)

export default component.exports